// extracted by mini-css-extract-plugin
export default {"root":"JobStatusChart_root__1Zccf","title":"JobStatusChart_title__jklZH","link":"JobStatusChart_link__EmwRM"};